import { z } from 'zod';

export interface Address {
  id: string;
  neighborhoodId: string;
  stateOrDepartmentId?: string;
  cityId?: string;
  streetName: string;
  doorNumber: string;
  corner?: string;
  apartmentNumber?: string;
  lat?: string;
  long?: string;
  createdAt: string;
  updatedAt: string;
  stateOrDepartment?: {
    id: string;
    name: string;
  };
  city?: {
    id: string;
    name: string;
  };
  neighborhood?: {
    id: string;
    name: string;
    cityId?: string;
    city?: {
      id: string;
      name: string;
      stateOrDepartmentId?: string;
      stateOrDepartment?: {
        id: string;
        name: string;
      };
    };
  };
}

export interface NewAddress {
  neighborhoodId?: string;
  cityId?: string;
  streetName: string;
  doorNumber: string;
  corner?: string;
  apartmentNumber?: string;
  lat?: string;
  long?: string;
}

export interface UpdateAddress {
  neighborhoodId?: string;
  cityId?: string;
  streetName?: string;
  doorNumber?: string;
  corner?: string;
  apartmentNumber?: string;
  lat?: string;
  long?: string;
}

export const addressSchema = z.object({
  neighborhoodId: z.string().min(1, 'El barrio es requerido'),
  streetName: z.string().min(1, 'El nombre de la calle es requerido'),
  doorNumber: z.string().min(1, 'El número de puerta es requerido'),
  corner: z.string().optional(),
  apartmentNumber: z.string().optional(),
  lat: z.string().optional(),
  long: z.string().optional(),
});

export const updateAddressSchema = addressSchema.partial();

export type AddressSchema = z.infer<typeof addressSchema>;
export type UpdateAddressSchema = z.infer<typeof updateAddressSchema>;

export const defaultAddressValues: AddressSchema = {
  neighborhoodId: '',
  streetName: '',
  doorNumber: '',
  corner: '',
  apartmentNumber: '',
  lat: '',
  long: '',
};
